/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrganizationPaymentPromotionCodeResponseDataFromJSON, GetOrganizationPaymentPromotionCodeResponseDataToJSON } from './GetOrganizationPaymentPromotionCodeResponseData';
export function GetOrganizationPaymentPromotionCodeResponseFromJSON(json) {
    return GetOrganizationPaymentPromotionCodeResponseFromJSONTyped(json, false);
}
export function GetOrganizationPaymentPromotionCodeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: GetOrganizationPaymentPromotionCodeResponseDataFromJSON(json['data'])
    };
}
export function GetOrganizationPaymentPromotionCodeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetOrganizationPaymentPromotionCodeResponseDataToJSON(value.data)
    };
}
